import { APPLICANT_ATTRIBUTION_BOTH, APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from './regex.utils';

export const schemaId = z.string().uuid();

// TODO what else could we do here? positive?
export const schemaBigDecimal = z.number();
export const schemaInteger = z.number().int();

export const schemaApplicantAttributionBoth = z.nativeEnum(APPLICANT_ATTRIBUTION_BOTH);
export const schemaApplicantAttribution = z.nativeEnum(APPLICANT_ATTRIBUTIONS);

export const schemaIsoDate = z.string().regex(regex_iso_date);
export const schemaTimestamp = z.number().int().positive();
